const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"
const Logistics = 'Logistics'
const Seller = 'Seller'
const CreditAnalyst = 'CreditAnalyst'

const TrucksRoutes = [
  {
    path: '/trucks/create',
    name: 'CreateTruck',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_registrations/components/trucks/CreateTruck.vue'),
    children: [
      {
        path: 'exists/:id',
        name: 'TruckExist',
        component: () => import('@/_backoffice/_registrations/components/trucks/TruckExist.vue'),
      }
    ]
  },
  {
    path: '/trucks',
    name: 'IndexTrucks',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_registrations/pages/Trucks.vue'),
    children:[
      {
        path: ':id',
        name: 'ShowTruck',
        meta: { 
          auth: true ,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
        },
        component: () => import("@/_backoffice/_registrations/components/trucks/EditTruck.vue"),
      },
    ]
  },

]


export default TrucksRoutes